import AuthMixin from '@/components/mixins/auth-mixin'
import OnEnterMixin from '@/components/mixins/onenter-mixin'
import ResetPassword from '@/components/common/sign-in/forgot-password-reset-password.vue'
import EventBus from '@/components/mixins/event-bus-mixin'
import { useScreenSize } from '@base-shared/composables/use-screen-size';
import { useUserStore } from '@base-shared/stores/user';

export default {
  name: 'userAccount',
  inject: [
    '$currentUser',
    '$utils',
    '$api',
    '$apiError'
  ],
  components: {
    ResetPassword
  },
  props: {
    data: {
      type: Object,
      default () { return {} }
    },
    props: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    /**
     * Watches the `userStore.currentUser` for changes. Replacement
     * for the old `USER_DETAILS_AVAILABLE_IN_VUE` from EventBus.
     */
    'userStore.currentUser': {
      handler (newValue) {
        if (!this.email && newValue?.email) this.email = newValue.email
      },
      deep: true
    }
  },
  mixins: [AuthMixin, OnEnterMixin],

  setup () {
    const { isPageMini } = useScreenSize();

    // return to expose to template or Options API methods
    return {
      isPageMini,
      userStore: useUserStore()
    };
  },
  data () {
    return {
      loginProvider: 'arya',
      panelHeaderIcon: { icon: true },
      panelAcccountIcon: { icon: true, arya: false, facebook: false, google: false },
      panelHeaderTitle: 'ARYA ID',
      panelContent: 'userDetails',
      email: '',
      changeEmailForm: {},
      changeEmailFormRules: {
        email: [
          { required: true, message: this.$t('label.requiredEmail') }
        ]
      },
      accountGroupId: this.$currentUser.getUserGroupId(),
      accountUserId: this.$currentUser.getUserId(),
      accountLogo: {
        url: '/static/images/logo-64.png',
        type: 'spinetix',
        link: null,
        show: true
      },
    }
  },
  methods: {
    handleChangeAccountBtnClick (type) {
      this.panelHeaderIcon = { icon: true, arya: false, facebook: false, google: false }

      if (type === 'changeEmail') {
        this.panelHeaderTitle = this.$t('label.email')
        this.panelContent = 'changeEmail'
      }

      if (type === 'changePassword') {
        this.panelHeaderTitle = this.$t('label.password')
        this.panelContent = 'changePassword'
      }

      if (type === 'passwordChanged') {
        this.panelHeaderTitle = this.$t('label.password')
        this.panelContent = 'passwordChanged'
      }
    },

    handleResetPasswordClick () {
      this.panelHeaderIcon = { icon: true, arya: false, facebook: false, google: false }
      this.panelHeaderTitle = this.$t('label.password')
      this.panelContent = 'changePassword'
    },
    setAccountContentToDefault (type) {
      this.panelContent = 'userDetails'
      this.panelHeaderTitle = `${CONFIG.PRODUCT_NAME_SHORT} ID`
      this.getProviderLogin()
    },
    getProviderLogin () {
      // Get Provider Name
      const userDetails = this.$currentUser.getUserDetails()
      let providerName = 'arya'

      if (userDetails.identities && userDetails.identities.length > 0) {
        providerName = userDetails.identities[0].providerName
      }

      this.loginProvider = providerName.toLowerCase()

      const panelAcccountIcon = this.$utils.clone(this.panelAcccountIcon)
      panelAcccountIcon[this.loginProvider] = true
      this.panelAcccountIcon = panelAcccountIcon

      this.email = userDetails.email
    },
    confirmChangeEmail () {
      const formEl = $(this.$refs.changeEmailForm.$el)
      formEl.find('.el-form-item').removeClass('animated shake')

      this.$refs.changeEmailForm.validate((isFormValid) => {
        if (isFormValid) {
          const changeEmailRequest = () => {
            const requestData = { email: this.changeEmailForm.email.toLowerCase() }
            this.$utils.mainLoader(true)
            this.$api.put(`${CONFIG.API_BASE_URL}/group/users/me`, requestData)
              .then(response => {
                // Update user session
                this.refreshUserSession({
                  nextAction: () => {
                    this.setAccountContentToDefault('emailChanged')
                    this.changeEmailForm = {}
                    this.email = requestData.email
                    this.$utils.mainLoader(false)
                  }
                })
              })
              .catch((error) => {
                this.$utils.mainLoader(false)

                // Change error message if email already exist
                if (error.response.data.message.includes('email already exists')) {
                  error.response.data.name = this.$t('label.emailAlreadyExists')
                }

                this.$apiError.handleAPIRequestError(error, { originalRequest: () => { changeEmailRequest() }, showDialogNotification: true })
              })
          }

          EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
            type: 'warning',
            title: this.$t('label.warning'),
            alert: {
              message: this.$t('confirm.changeEmail')
            },
            confirmButtonText: this.$t('label.continue'),
            callbacks: {
              eventOKButtonClick: () => {
                changeEmailRequest()
              }
            }
          })
        } else {
          this.$nextTick(() => {
            // Animate error fields
            formEl.find('.el-form-item').each((indx, el) => {
              if (($(el).hasClass('is-error'))) {
                window.setTimeout(() => { this.$utils.animate(el, 'animated shake') }, 1)
              }
            })
          })

          return false
        }
      })
    },
    onEnter (event) {
      if (event.target.id === 'user-account-email-input') {
        this.confirmChangeEmail()
      }
    },
  },
  mounted () {
    this.setAccountContentToDefault()
  },
}
